import Icon from '../components/Icon.vue'

Icon.register({
  'lock-open': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M423.5 0C339.5 0.3 272 69.5 272 153.5V224H48C21.5 224 0 245.5 0 272V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V272C448 245.5 426.5 224 400 224H352V152.9C352 113.3 383.7 80.4 423.3 80 463.3 79.6 496 112.1 496 152V232C496 245.3 506.7 256 520 256H552C565.3 256 576 245.3 576 232V152C576 68 507.5-0.3 423.5 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/lock-open.js
// module id = 0GKi
// module chunks = 144